import * as Scrivito from "scrivito";

const BentoGridWidget = Scrivito.provideWidgetClass("BentoGridWidget", {
  attributes: {
    content: ["widgetlist", { only: ["BentoItemWidget"] }],
  },
  extractTextAttributes: ["content"],
});

export default BentoGridWidget;
